import { render, staticRenderFns } from "./MoleculeFitoutSelector.vue?vue&type=template&id=3144cbbb&"
import script from "./MoleculeFitoutSelector.vue?vue&type=script&lang=js&"
export * from "./MoleculeFitoutSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeFitoutSelector.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeFitoutSelector.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsProjectAtomSpaceDropdown: require('/app/components/atoms/project/AtomSpaceDropdown.vue').default})
